import { styled } from '@mui/material';

export const SBottomSpacer = styled('div')({
  height: 16,
  width: '100%',
});

export const SIllustration = styled('img')({
  display: 'block',
  height: 120,
  width: 200,
});
